import { isOfflineMode } from "../shared/offlineManager";

export async function isReallyOnline() {
  if (isOfflineMode()) return false; // manual offline mode

  if (!navigator.onLine) return false;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 1000);

  try {
    const response = await fetch("https://www.google.com/generate_204", {
      method: "HEAD",
      mode: "no-cors",
      cache: "no-store",
      signal: controller.signal,
    });

    // "opaque" means the request went through but CORS prevented visibility
    return response.type === "opaque";
  } catch (error) {
    return false;
  } finally {
    clearTimeout(timeoutId);
  }
}
